var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('network.text_142')}}),_c('page-body',[_c('list',{attrs:{"id":_vm.listId,"get-params":_vm.getParams}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }